// patient-clinical-data.service.ts (nuevo servicio facade)
import { forkJoin, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BORelativeDisease } from '../models/BORelativeDisease.model';
import { BOPatientFarmacologicRecord } from '../models/BOPatientFarmacologicRecord.model';
import { RelativeDiseaseService } from './relativeDisease.service';
import { PatientAllergiesService } from './PatientAllergies.service';
import { PatientFarmacologicRecordService } from './PatientFarmacologicRecords.service';
import { PatientRiskFactorService } from './patientRiskFactor.service';
import { DiagnosticNovoService } from './diagnosticNovo.service';
import { Injectable } from '@angular/core';
import { BOPatientAllergies } from '../models/BOPatientAllergies.model';
import { BOPatientRiskFactor } from '../models/BOPatientRiskFactor.model';
import { BODiagnosticNovo } from '../models/BODiagnosticNovo.model';
import { ChControlService } from './chControl.service';
import { BOChControl } from '../models/BOChControl.model';
import { BOClinicHistoryObservations } from '../../../src/app/models/BOClinicHistoryObservations.model';
import { ClinicHistoryObservationsService } from './clinicHistoryObservations.service';

export interface PatientClinicalData {
  relativeDiseases: BORelativeDisease[];
  allergies: BOPatientAllergies[];
  farmacologicRecords: BOPatientFarmacologicRecord[];
  riskFactors: BOPatientRiskFactor[];
  diagnostics: BODiagnosticNovo[];
  chControls : BOChControl[];
  //chObservations: BOClinicHistoryObservations[];
}

@Injectable({ providedIn: 'root' })
export class PatientClinicalDataService {

  constructor(
    private _relativeDiseaseService: RelativeDiseaseService,
    private _patientAllergiesService: PatientAllergiesService,
    private _patientFarmacologicRecordService: PatientFarmacologicRecordService,
    private _patientRiskFactorService: PatientRiskFactorService,
    private _patientDiagnosticService: DiagnosticNovoService,
    private _chControlService        : ChControlService,
    //private _chObservationsService   : ClinicHistoryObservationsService,
  ) {}

  // ✅ Un solo método reutilizable en las 3 rutinas que lo necesitan
  getAllPatientClinicalData(patientId: number, clinicHistoryId: number): Observable<PatientClinicalData> {
    return forkJoin({
      relativeDiseases: this._relativeDiseaseService.getAllByPatientiD(patientId),
      allergies: this._patientAllergiesService.getAllByPatientId(patientId),
      farmacologicRecords: this._patientFarmacologicRecordService.getAllByPatientId(patientId),
      riskFactors: this._patientRiskFactorService.getAllByPatientId(patientId),
      diagnostics: this._patientDiagnosticService.getAllByPatientIdAndClinicId(patientId, clinicHistoryId),
      chControls: this._chControlService.getAllByClinicHistoryId(clinicHistoryId),
      //chObservations: this._chObservationsService.getAllByClinicHistoryId(clinicHistoryId)
    });
  }
}
